export function getVideoOptions() {
  const defaultOptions = { autoplay: true, muted: true }
  return iosPlatform() ? { ...defaultOptions, playsinline: true } : defaultOptions
}

function iosPlatform() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export function isMac() {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0
}
